import { useState, type FormEvent } from "react";
import { api } from "../lib/api";
import { useSetUser } from "../lib/auth";

export function Login() {
  const setUser = useSetUser();
  const [mode, setMode] = useState<"login" | "register">("login");
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  async function onSubmit(event: FormEvent<HTMLFormElement>) {
    event.preventDefault();
    const form = new FormData(event.currentTarget);
    const email = String(form.get("email"));
    const password = String(form.get("password"));
    setBusy(true);
    setError(null);
    try {
      const user =
        mode === "login"
          ? await api.login({ email, password })
          : await api.register({
              name: String(form.get("name")),
              email,
              password,
              timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
              inviteCode: String(form.get("inviteCode") ?? "") || undefined,
            });
      setUser(user);
    } catch (e) {
      setError((e as Error).message);
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="auth">
      <img src="/icon-192.png" alt="" width={72} height={72} className="auth-logo" />
      <h1>Hábitos</h1>
      <p className="muted">Tus rutinas, a su hora, un paso a la vez.</p>

      <form onSubmit={onSubmit} className="card form">
        {mode === "register" && (
          <label>
            Tu nombre
            <input name="name" required maxLength={60} autoComplete="given-name" />
          </label>
        )}
        <label>
          Correo
          <input name="email" type="email" required autoComplete="email" inputMode="email" />
        </label>
        <label>
          Contraseña
          <input
            name="password"
            type="password"
            required
            minLength={mode === "register" ? 8 : 1}
            autoComplete={mode === "login" ? "current-password" : "new-password"}
          />
        </label>
        {mode === "register" && (
          <label>
            Código de invitación <span className="muted">(si te dieron uno)</span>
            <input name="inviteCode" autoComplete="off" />
          </label>
        )}
        {error && <p className="error">{error}</p>}
        <button className="btn primary" disabled={busy}>
          {mode === "login" ? "Entrar" : "Crear cuenta"}
        </button>
      </form>

      <button className="link" onClick={() => { setMode(mode === "login" ? "register" : "login"); setError(null); }}>
        {mode === "login" ? "¿No tienes cuenta? Crea una" : "¿Ya tienes cuenta? Entra"}
      </button>
    </div>
  );
}
